module.exports = __webpack_public_path__ + "img/thumb-witlof-ham-kaas-met-boursin.32c8fff3.jpeg";